// import React from "react";
// import { Col } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import productOne from "../../assets/img/iron.jpg";
// import productTwo from "../../assets/img/brass.jpg";
// import productThree from "../../assets/other.webp";
// import productFour from "../../assets/img/spicesProduct.webp";
// import productFive from "../../assets/img/wood.jpg";
// import ProductSix from "../../assets/img/cultivation.jpg";
// import productSeven from "../../assets/img/foodProduct.jpg"
// import product from "../../assets/img/herbalProduct.webp";

// const titleStyles = {
//   fontSize: ".9em",
// };

// export default function ProductLayout() {
//   const productData = [
//     {
//       path: "/herbalProduct",
//       img: productOne,
//       title: "Iron and cast iron ",
//     },
//     {
//       path: "/gardenProduct",
//       img: productTwo,
//       title: "Brass and bronze ",
//     },

//     {
//       path: "/yogaProduct",
//       img: productFive,
//       title: "wooden and toys",
//     },
//     {
//       path: "/spices",
//       img: ProductSix,
//       title: "soap stone",
//     },
//     {
//       path: "/combo",
//       img: productSeven,
//       title: "Combo offers",
//     },
//     {
//       path: "/bakery",
//       img: productFour,
//       title: "Bakery mould items",
//     },
//     {
//       path: "/unique",
//       img: product,
//       title: "Tin and tin coating product",
//     },
//     {
//       path: "/foodProduct",
//       img: productThree,
//       title: "Others",
//     },
//   ];

//   return (
//     <>
//       {productData.map((data, index) => {
//         return (
//           <Col xs={12} sm={6} md={4} lg={4} xl={3} className="mb-4" key={index + "product"}>
//             <div className="card h-100 d-flex flex-column">
//               <Link to={data.path} className="d-block">
//                 <img
//                   src={data.img}
//                   className="card-img-top"
//                   alt="Sri Mangalambika Stores products"
//                   style={{
//                     height: "300px",
//                     width: "100%",
//                     // objectFit: "cover",
//                     borderTopLeftRadius: "8px",
//                     borderTopRightRadius: "8px",
//                   }}
//                 />
//               </Link>
//               <div
//                 className="card-body d-flex justify-content-center align-items-center"
//                 style={{ boxShadow: "1px 1px 20px rgba(183, 180, 180, 0.5)" }}
//               >
//                 <Link
//                   to={data.path}
//                   className="h6 text-decoration-none text-uppercase text-dark text-center productTitle"
//                   style={titleStyles}
//                 >
//                   {data.title}
//                 </Link>
//               </div>
//             </div>
//           </Col>
//         );
//       })}
//     </>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";

import productOne from "../../assets/img/ironn.jpg";
import productTwo from "../../assets/img/brass.jpg";
import productThree from "../../assets/img/other.jpg";
import productFour from "../../assets/img/iron.jpg";
import productFive from "../../assets/img/wooden.jpg";
import ProductSix from "../../assets/img/soap.jpg";
import productSeven from "../../assets/img/combo.jpg";
import product from "../../assets/img/tin.jpg";

export default function ProductLayout() {
  const productData = [
    { path: "/herbalProduct", img: productOne, title: "Iron and cast iron" },
    { path: "/gardenProduct", img: productTwo, title: "Brass and bronze" },
    { path: "/yogaProduct", img: productFive, title: "Wooden and toys" },
    { path: "/spices", img: ProductSix, title: "Soap stone" },
    { path: "/combo", img: productSeven, title: "Combo offers" },
    { path: "/bakery", img: productFour, title: "Bakery mould items" },
    { path: "/unique", img: product, title: "Tin and tin coating product" },
    { path: "/foodProduct", img: productThree, title: "Others" },
  ];

  return (
    <>
      {/* Desktop Grid */}
      <div className="desktop-grid">
        {productData.map((data, index) => (
          <div key={index} className="desktop-card">
            <Link to={data.path}>
              <img src={data.img} alt="product" />
            </Link>
            <div className="card-title">{data.title}</div>
          </div>
        ))}
      </div>

      {/* Mobile Horizontal Scroll */}
      <div className="mobile-scroll">
        {productData.map((data, index) => (
          <div key={index} className="mobile-card">
            <Link to={data.path}>
              <img src={data.img} alt="product" />
            </Link>
            <div className="card-title">{data.title}</div>
          </div>
        ))}
      </div>
    </>
  );
}
